import { Box, keyframes } from '@mui/material'

const pulse = keyframes`
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
`

/**
 * Componente que muestra un texto de "Validando..." con un punto parpadeante
 * Similar al estilo de "thinking" de Claude Code
 */
function ValidatingText() {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        color: 'text.secondary',
        fontSize: '0.75rem',
      }}
    >
      <Box
        component="span"
        sx={{
          width: 4,
          height: 4,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          animation: `${pulse} 1.4s ease-in-out infinite`,
        }}
      />
      Validando...
    </Box>
  )
}

export default ValidatingText
